// extracted by mini-css-extract-plugin
export var container = "_uy-0";
export var table = "_uy-2";
export var tableWrapper = "_uy-1";